import { safePosthogFeatureFlags } from "./postHog";

export enum FeatureFlag {
  AccountingAutoBalanceBanner = "accounting-auto-balance-banner",
  AiLabsFollowUp = "ai-labs-followup",
  ApolloCachePersistor = "apollo-cache-persistor",
  ARAging = "ar-aging-by-customer",
  CashAcrrualReportDefaultFilter = "cash-acrrual-default-report-filter",
  ClassesAndDeptsCols = "classes-and-depts-cols",
  ClassesAndDeptsM1 = "classes-and-depts-m1",
  CustomersPage = "customers-page",
  CutoverDateV2 = "cutover-date-v2",
  ConfirmProvisionedRipplingEmployees = "confirm-provisioned-rippling-employees",
  DashboardChartBurnComparison = "dashboard-chart-burn-comparison",
  DashboardFsReportsWithStatus = "dashboard-fs-reports-with-status",
  DashboardShowPercentageChanged = "dashboard-show-percentage-changed",
  DashboardSpotlightShowGroupingDropdown = "dashboard-spotlight-show-grouping-dropdown",
  DecimalSecondaryDashboardCharts = "decimal-secondary-dashboard-charts",
  DevOnlyFlagOverrideNonFirmOwnerCheck = "dev-only-flag-override-non-firm-only-check",
  EditPostedBill = "edit-posted-bills",
  EditPostedBillWithSchedules = "edit-posted-bills-with-schedules",
  EducationBanners = "education-banners",
  EnableEventBreakout = "enable-event-breakout",
  EveryIntegrationVisible = "every-integration-visible",
  FeatureOnboardingRules = "feature-onboarding-rules",
  FixedAssetsAutoDepreciation = "fixed-assets-auto-depreciation",
  FStoFilteredGL = "fs_to_filtered_gl",
  GeneralLedgerMRT = "general-ledger-mrt",
  GeneralLedgerEmptyState = "general-ledger-empty-state",
  GroupCategoriesByAccount = "group-categories-by-account",
  HistoricalBooksV2 = "historical-books-v2",
  InexactBillMatch = "inexact-bill-match",
  IntroFlowNewOnboardingFunnel = "intro-flow-new-onboarding-funnel",
  InvoicingV2 = "invoicing-v2",
  MapAccountToCoa = "map-account-to-coa",
  MJECombinedCounterpartyField = "mje-combined-counterparty-field",
  MultipleIntegrationConnections = "multiple-integration-connections",
  ProductsPage = "products-page",
  ReqIngestOprionOnReconnectIntegration = "req-ingest-oprion-on-reconnect-integration",
  RevenueRecognitionOnboarding = "rev-rec-onboarding",
  RevRecRules = "revrec-rules",
  SetStripeEpoch = "set-stripe-epoch",
  SetupChecklist = "setup-checklist",
  SkipTrial = "skip-trial",
  ShowAddonPuzzleAI = "show-addon-puzzleai",
  SubscriptionUpdatedModal = "subscription-updated-modal",
  TransactionsEducationBanner = "transactions-education-banner",
  UnlinkBills = "unlink-bills",
  VendorsV2 = "vendors-v2",
  Z = "zindex",
  BulkClassifyTransactions = "bulk-classify-transactions",
  SplitsV2 = "splits-v2",
  PhoneNumberInput = "phone-number-input",
  ClassificationRules = "classification-rules",
  BypassOnboardingConnectionSteps = "bypass-onboarding-connection-steps",
  AccuracyReviewSetting = "accuracy-review-setting",
  ActiveCompanyLogging = "active-company-logging",
  StripeReconciliations = "stripe-recons",
  StripeFullDetails = "stripe-full-details",
  PhoneNumberRequiredTest = "phone-number-required-test",
  UseCategoryDropdown = "use-category-dropdown",
  DashboardCustomizeButton = "dashboard-customize-button",
  EnableChurnkey = "enable-churnkey",
  TransactionsNoFIEmptyStates = "transactions-no-fi-empty-states",
  ReconAttachmentSidebarV2 = "recon-attachment-sidebar-v2",
  SidebarAddReviewMenu = "sidebar-add-review-menu",
  NewHowDidYouHearAboutUsField = "new-hdyhau-field",
  SidebarPartialMinimized = "sidebar-partial-minimized",
  UnconfirmContractLinesWithoutSchedules = "unconfirm-contract-lines-without-schedules",
  OnboardingLaunchpadVariants = "onboarding-launchpad-variants",
  RedirectLogging = "redirect-logging",
  FirmSelect = "firm-select",
  CrossSellFondoToCCorps = "cross-sell-fondo-to-ccorps",
  CrossSellFondoToAllCompanies = "cross-sell-fondo-to-all-companies",
  CrossSellGustoToCompaniesWithoutPayroll = "cross-sell-gusto-to-companies-without-payroll",
  CrossSellGustoToAllCompanies = "cross-sell-gusto-to-all-companies",
  CrossSellBrexToAllCompanies = "cross-sell-brex-to-all-companies",
  CrossSellBrexToCompaniesWithoutCreditCard = "cross-sell-brex-to-companies-without-credit-card",
  OnboardingLaunchpadForceBrex = "onboarding-launchpad-force-brex",
  RecurringMjeSchedulesEndDateEditable = "recurring-mje-schedules-end-date-editable",
  OnboardingTryDemoModal = "onboarding-try-demo-modal",
  MjeGroupsInNav = "mje-groups-in-nav",
  OnboardingLaunchpadCheckBrex = "onboarding-launchpad-check-brex",
  StripeDetailDateFilter = "stripe-detail-date-filter",
}

// Manually override flags to be enabled on local + dev for testing
export const FLAGS_ENABLED_ON_DEV = [
  FeatureFlag.FixedAssetsAutoDepreciation,
  FeatureFlag.ARAging,
  FeatureFlag.ClassesAndDeptsM1,
  FeatureFlag.UnlinkBills,
  FeatureFlag.ApolloCachePersistor,
  FeatureFlag.SetStripeEpoch,
  FeatureFlag.GeneralLedgerMRT,
  FeatureFlag.InexactBillMatch,
  FeatureFlag.RevRecRules,
  FeatureFlag.CutoverDateV2,
  FeatureFlag.MapAccountToCoa,
  FeatureFlag.PhoneNumberInput,
  FeatureFlag.ClassificationRules,
  // FeatureFlag.IntroFlowNewOnboardingFunnel, // For testing new onboarding funnel
  // FeatureFlag.ActiveCompanyLogging, // turn on for logging in local development
  // FeatureFlag.RedirectLogging, // turn on for logging in local development
  // FeatureFlag.DashboardChartBurnComparison, // for testing Net Burn MoM card
  FeatureFlag.RevenueRecognitionOnboarding,
  // FeatureFlag.HistoricalBooksV2, // for testing new historical books
  FeatureFlag.EducationBanners,
  FeatureFlag.MJECombinedCounterpartyField,
  FeatureFlag.CustomersPage,
  FeatureFlag.BulkClassifyTransactions,
  FeatureFlag.AccuracyReviewSetting,
  FeatureFlag.StripeReconciliations,
  FeatureFlag.StripeFullDetails,
  FeatureFlag.EnableChurnkey,
  FeatureFlag.BypassOnboardingConnectionSteps,
  FeatureFlag.UnconfirmContractLinesWithoutSchedules,
  FeatureFlag.EveryIntegrationVisible,
  FeatureFlag.RecurringMjeSchedulesEndDateEditable,
  FeatureFlag.MjeGroupsInNav,
  FeatureFlag.StripeDetailDateFilter,
];

// Manually override flags to be enabled on staging
// Careful! staging is used for demos, make sure the feature is suited for a demo environment
export const FLAGS_ENABLED_ON_STAGING = [];

export const isPosthogFeatureFlagEnabled = (featureFlag: FeatureFlag) => {
  // this allows for setting permanent feature flags in the ENV (local or otherwise)
  // presence of the var == flag set globally
  if (process.env["FFLAG_" + (featureFlag as string).replace("-", "_").toUpperCase()]) {
    return true;
  }
  return safePosthogFeatureFlags()?.isFeatureEnabled(featureFlag, { send_event: false });
};

export const reloadFeatureFlags = () => {
  safePosthogFeatureFlags()?.reloadFeatureFlags();
};

export const getFeatureFlag = (featureFlag: FeatureFlag) => {
  return safePosthogFeatureFlags()?.getFeatureFlag(featureFlag);
};
